import * as React from 'react';

import { ContentCard, Loading } from '@rematter/ui-web';
import { useAtomValue } from 'jotai';

import * as state from '../../_state/loadDetails.state';
import { PhotoAlbum } from '../_shared/PhotoAlbum';

export const LoadTabPhotos = () => {
  const { data: loadPhotos } = useAtomValue(state.$loadPhotos);
  const { data: materialPhotos } = useAtomValue(state.$loadMaterialPhotos);
  const isLoadingPhotos = useAtomValue(state.$isLoadingPhotos);

  return (
    <div className="@LoadTabPhotos flex flex-col gap-2.5 p-5">
      <Loading isLoading={isLoadingPhotos}>
        <ContentCard>
          <PhotoAlbum photos={loadPhotos} title="Load Photos" />
        </ContentCard>
        <ContentCard>
          <PhotoAlbum photos={materialPhotos} title="Material Photos" />
        </ContentCard>
      </Loading>
    </div>
  );
};
